<template>
  <swiper :options="swiperOption">

    <swiper-slide v-for="item, key in data" :key="key">
      <div class="btn-item-added">{{ item.name }}<a class="remove" @click.stop.prevent="removeTag(item.id, item.name)"></a></div>
    </swiper-slide>

    <div class="slide-prev" slot="button-prev"></div>
    <div class="slide-next" slot="button-next"></div>
  </swiper>
</template>

<script>
export default {
  props: ['data', 'items'],
  data () {
    return {
      centeredSlides: 'false',
      swiperOption: {
        paginationClickable: true,
        nextButton: '.slide-next',
        prevButton: '.slide-prev',
        spaceBetween: 10,
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    }
  },
  methods: {
    removeTag (id, name) {
      let index = this.$parent.selectedItems.indexOf(id)
      this.$parent.selectedItems.splice(index, 1)
      this.$parent.selectedItemTags.splice(index, 1)
    }
  },
  computed: {
    noOfSlides: function () {
      let slides = this.items
      if (slides > 3) {
        slides = 3
      }
      if (slides > 1) {
        this.centeredSlides = 'true'
      } else {
        this.centeredSlides = 'false'
      }
      return slides
    }
  }
}
</script>



// WEBPACK FOOTER //
// Slider.vue?cab462da